/** @format */

import apiSlice from './api-slice';

export const carApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCars: builder.query({
      query: ({ modelKey, ...params }) => ({
        url: `/car/all${modelKey ? `/${modelKey}` : ''}`,
        method: 'GET',
        params: params
      }),
      providesTags: ['Car']
    }),
    getWithCheckAvailableCars: builder.query({
      query: ({ ...params }) => ({
        url: '/car/all/withCheckAvailableCars',
        method: 'GET',
        params: params
      }),
      providesTags: ['CarCheckAvailableBSchedule']
    }),
    getCarSchedules: builder.query({
      query: ({ fromDate, toDate, isGroup, pageNumber, pageSize, ...params }) => ({
        url: '/car-schedules/available-dates',
        method: 'POST',
        body: {
          fromDate,
          toDate,
          isGroup,
          pageNumber,
          pageSize,
          ...params
        }
      }),
      providesTags: ['CarSchedules']
    }),
    getCarScheduleByCarId: builder.query({
      query: (carId) => ({
        url: `/car-schedules/${carId}`,
        method: 'GET'
      }),
      providesTags: ['CarSchedules']
    }),
    getCar: builder.query({
      query: ({ id, ...params }) => ({
        url: `/car/${id}`,
        method: 'GET',
        params: params
      }),
      providesTags: ['Car']
    }),
    getListVehicles: builder.query({
      query: (body) => ({
        url: '/car/vehicles/list',
        method: 'POST',
        body
      }),
      providesTags: ['CarListVehicles']
    }),

    createCar: builder.mutation({
      query: (params) => ({
        url: '/car',
        method: 'POST',
        body: params
      }),
      invalidatesTags: ['Car']
    }),
    updateCar: builder.mutation({
      query: ({ id, formData, ...params }) => {
        const body = formData ? formData : params;
        return {
          url: `/car/${id}`,
          method: 'PATCH',
          body: body
        };
      },
      invalidatesTags: ['Car']
    }),
    deleteCar: builder.mutation({
      query: (id) => {
        return {
          url: `/car/${id}`,
          method: 'DELETE'
        };
      },
      invalidatesTags: ['Car']
    }),
    upsertCarSchedule: builder.mutation({
      query: ({ carId, busy_dates }) => ({
        url: '/car-schedules',
        method: 'POST',
        body: {
          carId,
          busy_dates
        }
      }),
      invalidatesTags: ['CarSchedules']
    })
  })
});

export const {
  useGetCarsQuery,
  useGetWithCheckAvailableCarsQuery,
  useGetCarSchedulesQuery,
  useGetCarScheduleByCarIdQuery,
  useGetCarQuery,
  useLazyGetCarQuery,
  useCreateCarMutation,
  useUpdateCarMutation,
  useDeleteCarMutation,
  useGetListVehiclesQuery,
  useUpsertCarScheduleMutation
} = carApi;
